"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "flex flex-row flex-wrap" };
const _hoisted_2 = { value: "" };
const _hoisted_3 = ["value"];
const _hoisted_4 = ["selected"];
const _hoisted_5 = ["value"];
const _hoisted_6 = ["selected"];
const _hoisted_7 = ["value"];
const _hoisted_8 = ["selected"];
const _hoisted_9 = ["value"];
const _hoisted_10 = {
    key: 0,
    class: "small-mt-top"
};
const _hoisted_11 = { class: "flex flex-wrap flex-row" };
const _hoisted_12 = ["onClick"];
const vue_3 = require("vue");
const CustomSelect_vue_1 = __importDefault(require("../../../components/frontend/CustomSelect.vue"));
const Form_1 = require("../../../components/Form");
const lodash_1 = require("lodash");
const wheelSizeStore_1 = require("../../../stores/wheelSize/wheelSizeStore");
const bookAppointmentStore_1 = require("../../../stores/bookAppointment/bookAppointmentStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CarDatas',
    setup(__props) {
        const selectedMarka = (0, vue_3.ref)(0);
        const gyartasiActive = (0, vue_3.ref)(false);
        const selectedGyartEv = (0, vue_3.ref)(null);
        const selectedTipus = (0, vue_3.ref)(0);
        const tipusActive = (0, vue_3.ref)(false);
        const selectedKivitel = (0, vue_3.ref)(0);
        const kivitelIsSelected = (0, vue_3.ref)(false);
        const kivitelActive = (0, vue_3.ref)(false);
        const wheelSizeStore = (0, wheelSizeStore_1.useWheelSizeStore)();
        const bookAppointmentStore = (0, bookAppointmentStore_1.useBookAppointmentStore)();
        //console.log(bookAppointmentStore);
        wheelSizeStore.getCarBrands();
        const changeCarBrand = (e) => {
            selectedMarka.value = e.target.value;
            tipusActive.value = false;
            if (selectedMarka.value) {
                wheelSizeStore.getCarModells(wheelSizeStore.carBrands[selectedMarka.value].slug);
                tipusActive.value = true;
            }
            gyartasiActive.value = false;
            kivitelActive.value = false;
            kivitelIsSelected.value = false;
        };
        // típus választás
        const changeCarModel = (e) => {
            selectedTipus.value = e.target.value;
            kivitelActive.value = false;
            kivitelIsSelected.value = false;
            gyartasiActive.value = false;
            if (selectedTipus.value && selectedMarka.value) {
                wheelSizeStore.getCarYears(wheelSizeStore.carBrands[selectedMarka.value].slug, wheelSizeStore.carModels[selectedTipus.value].slug);
                gyartasiActive.value = true;
            }
        };
        //gyártási év kiválasztása
        const changeCarYear = (e) => {
            selectedGyartEv.value = e.target.value;
            kivitelActive.value = false;
            kivitelIsSelected.value = false;
            if (selectedMarka.value && selectedTipus.value && selectedGyartEv.value) {
                wheelSizeStore.getCarDetails(wheelSizeStore.carBrands[selectedMarka.value].slug, wheelSizeStore.carYears[selectedGyartEv.value].slug, wheelSizeStore.carModels[selectedTipus.value].slug);
                kivitelActive.value = true;
            }
        };
        const changeCarEngine = (e) => {
            selectedKivitel.value = e.target.value;
            kivitelIsSelected.value = true;
            bookAppointmentStore.carDatas.carBrand =
                wheelSizeStore.carBrands[selectedMarka.value].name;
            bookAppointmentStore.carDatas.carBrandSlug =
                wheelSizeStore.carBrands[selectedMarka.value].slug;
            if (selectedGyartEv.value !== null) {
                bookAppointmentStore.carDatas.carYearOfProduction = Number(wheelSizeStore.carYears[selectedGyartEv.value].name);
            }
            bookAppointmentStore.carDatas.carModel =
                wheelSizeStore.carModels[selectedTipus.value].name;
            bookAppointmentStore.carDatas.carModelSlug =
                wheelSizeStore.carModels[selectedTipus.value].slug;
            bookAppointmentStore.carDatas.carEngine =
                wheelSizeStore.carDetails[selectedKivitel.value].name;
            bookAppointmentStore.carDatas.carEngineSlug =
                wheelSizeStore.carDetails[selectedKivitel.value].slug;
        };
        const changeLicensePlate = (0, lodash_1.debounce)((e) => {
            if (e.target.value !== null && e.target.value.length >= 6) {
                bookAppointmentStore.carDatas.licencePlate = e.target.value;
            }
        }, 500);
        const changeTyreDiameter = (col, selectedElement) => {
            const HTMLelements = document.querySelectorAll(".car-col-btn.checked");
            HTMLelements.forEach((element) => {
                element.classList.remove("checked");
            });
            selectedElement.classList.add("checked");
            bookAppointmentStore.tyreDatas.tyreDiameter = col;
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                        class: "car-input",
                        label: _ctx.$trans('license_plate', 'License plate', 'frontend_car_data_block'),
                        name: "rendszam",
                        "max-length": 10,
                        onInput: (0, vue_2.unref)(changeLicensePlate)
                    }, null, 8, ["label", "onInput"]),
                    (0, vue_2.createVNode)(CustomSelect_vue_1.default, {
                        class: "car-input",
                        label: _ctx.$trans('car_brand', 'Brand', 'frontend_car_data_block'),
                        name: "marka",
                        onChange: changeCarBrand
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("option", _hoisted_2, (0, vue_2.toDisplayString)(_ctx.$trans("choose", "Choose!", "frontend_car_data_block")), 1),
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(wheelSizeStore).carBrands, (brand, index) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                    key: index,
                                    value: index
                                }, (0, vue_2.toDisplayString)(brand.name), 9, _hoisted_3));
                            }), 128))
                        ]),
                        _: 1
                    }, 8, ["label"]),
                    (0, vue_2.createVNode)(CustomSelect_vue_1.default, {
                        active: tipusActive.value,
                        class: "car-input",
                        label: _ctx.$trans('car_model', 'Model', 'frontend_car_data_block'),
                        name: "tipus",
                        onChange: changeCarModel
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("option", {
                                value: "",
                                selected: !tipusActive.value
                            }, (0, vue_2.toDisplayString)(_ctx.$trans("choose", "Choose!", "frontend_car_data_block")), 9, _hoisted_4),
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(wheelSizeStore).carModels, (tipus, index) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                    key: index,
                                    value: index
                                }, (0, vue_2.toDisplayString)(tipus.name), 9, _hoisted_5));
                            }), 128))
                        ]),
                        _: 1
                    }, 8, ["active", "label"]),
                    (0, vue_2.createVNode)(CustomSelect_vue_1.default, {
                        active: gyartasiActive.value,
                        class: "car-input",
                        label: _ctx.$trans('car_year', 'Year of production', 'frontend_car_data_block'),
                        name: "gyartas",
                        onChange: changeCarYear
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("option", {
                                value: "",
                                selected: !gyartasiActive.value
                            }, (0, vue_2.toDisplayString)(_ctx.$trans("choose", "Choose!", "frontend_car_data_block")), 9, _hoisted_6),
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(wheelSizeStore).carYears, (year, index) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                    key: index,
                                    value: index
                                }, (0, vue_2.toDisplayString)(year.name), 9, _hoisted_7));
                            }), 128))
                        ]),
                        _: 1
                    }, 8, ["active", "label"]),
                    (0, vue_2.createVNode)(CustomSelect_vue_1.default, {
                        active: kivitelActive.value,
                        class: "car-input",
                        label: _ctx.$trans('car_engine', 'Engine', 'frontend_car_data_block'),
                        name: "kivitel",
                        onChange: changeCarEngine
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("option", {
                                value: "",
                                selected: !kivitelActive.value
                            }, (0, vue_2.toDisplayString)(_ctx.$trans("choose", "Choose!", "frontend_car_data_block")), 9, _hoisted_8),
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(wheelSizeStore).carDetails, (kivitel, index) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                    key: index,
                                    value: index
                                }, (0, vue_2.toDisplayString)(kivitel.name) + " (" + (0, vue_2.toDisplayString)(kivitel.horsepower) + " " + (0, vue_2.toDisplayString)(_ctx.$trans("horsepower", "HP", "frontend_car_data_block")) + ", " + (0, vue_2.toDisplayString)(" " + Math.round(kivitel.kilowatt)) + " " + (0, vue_2.toDisplayString)(_ctx.$trans("kilowatt", "kW", "frontend_car_data_block")) + ") ", 9, _hoisted_9));
                            }), 128))
                        ]),
                        _: 1
                    }, 8, ["active", "label"])
                ]),
                ((0, vue_2.unref)(wheelSizeStore).carDetails[selectedKivitel.value] && kivitelIsSelected.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, [
                        (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(_ctx.$trans("tyre_size", "Tyre size", "frontend_car_data_block")), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_11, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(wheelSizeStore).carDetails[selectedKivitel.value].wheels, (col, index) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                    key: index,
                                    class: "car-col-btn small-mt-top",
                                    onClick: ($event) => (changeTyreDiameter(col, $event.target))
                                }, (0, vue_2.toDisplayString)(col) + "\" ", 9, _hoisted_12));
                            }), 128))
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 64));
        };
    }
});
